import {useState, useEffect, useContext} from 'react';
import AuthenticationCodeList from './AuthCodeList';
import AuthenticationCodeSearchForm from '../SchoolAuthenticationCodeGenerator/AuthenticationCodeSearchForm';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import Loader from '../UI/Loader/Loader';
import style from '../SchoolAuthenticationCodeGenerator/SchoolAuthenticationCodeGenerator.module.css'
import { getAuthenticationCode, generateNewCode,getDeactiveAuthenticationCode } from '../../services/SchoolAuthenticationCodeGenerator.services';
import { toast } from 'react-toastify';
import AuthContext from "../../store/auth-context";
import button from '../Style/ButtonStyle.module.css';
import tableStyle from '../Style/TableModel.module.css';

//const orgUuid = '7bce8766-5bd8-4194-b455-ac579dc36587';

const SchoolAuthenticationCodeGenerator = (props) => {

    const [isGeneratingCode, setIsGeneratingCode] = useState(false);
    const [organisationCodes, setOrganisationCodes] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showTab, setShowTab] = useState(true);
    const authCtx = useContext(AuthContext);
    const orgUuid=authCtx.userData.orgId;
    useEffect(() => {
      
        if(orgUuid!=null){
            setIsLoading(true);
            getAuthenticationCode(orgUuid, authCtx.token)
            .then((response) => {
                console.log('Authentication Code Response:', response);
                const codeList = response?.data || response || [];
                console.log('Extracted codeList:', codeList);
                setOrganisationCodes(Array.isArray(codeList) ? codeList : []);
                setIsLoading(false);
                props.setHasVerificationCodeGenerated(codeList.length > 0);
            })
            .catch((err) => {
                console.error('Error fetching authentication codes:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
        }
       
    }, [orgUuid, authCtx.token]);

    const getDeActiveGenerateCode = () => {
        setIsLoading(true);
        getDeactiveAuthenticationCode(orgUuid,authCtx.token)
            .then((response) => {
                console.log('Deactive Code Response:', response);
                const codeList = response?.data || response || [];
                console.log('Extracted codeList:', codeList);
                setOrganisationCodes(Array.isArray(codeList) ? codeList : []);
                setIsLoading(false);
                setShowTab(false);
            })
            .catch((err) => {
                console.error('Error fetching deactive codes:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
    }


    const getActiveCodeList = () => {
        setIsLoading(true);
        getAuthenticationCode(orgUuid,authCtx.token)
            .then((response) => {
                console.log('Active Code Response:', response);
                const codeList = response?.data || response || [];
                console.log('Extracted codeList:', codeList);
                setOrganisationCodes(Array.isArray(codeList) ? codeList : []);
                setIsLoading(false);
                setShowTab(true);
            })
            .catch((err) => {
                console.error('Error fetching active codes:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
    }
    const generateNewCodeHandler = () => {

        setIsGeneratingCode(true);

        generateNewCode(orgUuid, authCtx.token)
            .then((response) => {
                console.log('Generate Code Response:', response);
                const generatedCode = response?.data || response;
                if(!generatedCode) {
                    throw new Error('Invalid response structure');
                }
                const newCode = {
                    id: generatedCode.id,
                    code: generatedCode.code,
                    createDate: generatedCode.createDate,
                    codeStatus: generatedCode.codeStatus,
                }
                const copyOrganisationCodes = [...organisationCodes];
                copyOrganisationCodes.unshift(newCode);
                setOrganisationCodes(copyOrganisationCodes);
                setIsGeneratingCode(false);

                toast.success("A new code generated successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    type: 'success'
                });
                props.setHasVerificationCodeGenerated(true);

            })
            .catch((err) => {
                console.error('Error generating code:', err);
                setIsGeneratingCode(false);
            });
    }

    const searchHandler = (searchInputText) => {
        setSearchText(searchInputText)
    }
    //let filterdCodes = '';
    //if(organisationCodes.length>0){
        const filterdCodes = organisationCodes.filter((c) => {
            if (searchText)
                return (c.code+'').includes(searchText);
            return true;
        });
    //}
   

    return (<>
        <div className="authentication-code-content">
            <div className={"row " + style.margin}>
                <div className={'col-md-6 ' + button.tabBox}>
                <button type="button" onClick={generateNewCodeHandler} className={button.modalBtn + ' ' + button.redButton + ' ' + button.iconBtn} disabled={isGeneratingCode} >
                        {!isGeneratingCode ? <> <i className="icon icon-unlocked"></i> Generate New </> : ''
                        }
                        {isGeneratingCode && <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating...
                        </>
                        }
                    </button>
                    {/* {!showTab && <ul className={button.tabButton}>
                            <li><button onClick={()=>{getActiveCodeList()}} >Active Code</button></li>
                            <li className={button.tabActive}><button onClick={()=>{getDeActiveGenerateCode()}} >DeActive Code</button></li>
                        </ul>
                    }
                    {showTab && <ul className={button.tabButton}>
                            <li  className={button.tabActive}><button onClick={()=>{getActiveCodeList()}}>Active Code</button></li>
                            <li><button onClick={()=>{getDeActiveGenerateCode()}} >DeActive Code</button></li>
                        </ul>
                    } */}
                    </div>

                    <div className='col-md-6'>
                <div className="search-box" style={{marginBottom:'0'}}>
                    <AuthenticationCodeSearchForm onSearch={searchHandler} />
                </div>
                </div>
            </div>
            {isLoading && <Loader />}
            <AuthenticationCodeList organisationCodes={filterdCodes} setOrganisationCodes={setOrganisationCodes} setKey={props.setKey} setSelectedCode={props.setSelectedCode} showTab={showTab}/>

        </div>
    </>
    )

}

export default SchoolAuthenticationCodeGenerator;
